import type { Plugin } from 'vibegame';
import { StepController } from './components';
import { createSystems, type SequenceMap } from './systems';

export function createPlugin(map: SequenceMap): Plugin {
  return {
    components: { StepController },
    systems: createSystems(map),
    config: {
      defaults: {
        'step-controller': { step: 0, target: 0, max: 0 },
      },
    },
  };
}
